/**
 * Composition method for endpoint section tabs navigation
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */
 import { ref, computed, onMounted } from 'vue';
 import { useRoute, useRouter } from 'vue-router';

 import { getSectionTierId, getEndpointTierId } from '../services/endpoint.helpers';
 import { getLyraEndpoints, getLyraEndpoint} from '@/core/modules/lyra/services';

export function endpointSectionsComposition () {
    const route = useRoute();
    const router = useRouter();
    
    const subSectionsId = 'sub-sections';
    const tabItems = ref<string[]>([]);
    const endpointId = computed((): string => route.params.endpointId as string);
    const sectionId = computed((): string => route.params.sectionId as string);
    const subSectionActive = computed((): string => {
        const endpointsTier = getEndpointTierId(sectionId.value);
        const endpointObj = getLyraEndpoint(endpointId.value, endpointsTier);
        
        return endpointObj[subSectionsId] ? endpointObj[subSectionsId] : '';
    });

    const pages = computed((): any[] => {
        const sectionsTier = getSectionTierId(sectionId.value);
        const endpointsTier = getEndpointTierId(sectionId.value);
        const endpointObj = getLyraEndpoint(endpointId.value, endpointsTier);
        const endpointObjAppSection = endpointObj[sectionsTier];
        const endpointAtAppSection = getCurrentTierEndpoints().filter((_: any) => _[sectionsTier] === endpointObjAppSection && _[subSectionsId]);
        return endpointAtAppSection;
    });

    const pageIndex = computed(() => {
        const pagesMap = pages.value.map((_: any) => _.endpointId);
        return pagesMap.indexOf(endpointId.value);
    })


    /**
     * Gets list of endpoints
     * @returns list of endpoints from current Tier
     */
    function getCurrentTierEndpoints (): any[] {
        const endpointsTier = getEndpointTierId(sectionId.value);
        const endpoints = getLyraEndpoints(endpointsTier);

        return endpoints;
    }

    /**
     * Get the sub sections from current section
     */
    function getTabItems (): void {
        const sectionsTier = getSectionTierId(sectionId.value);
        const endpointsTier = getEndpointTierId(sectionId.value);
        const endpointObj = getLyraEndpoint(endpointId.value, endpointsTier);
        const endpointObjAppSection = endpointObj[sectionsTier];
        const endpoints = getCurrentTierEndpoints();
        const endpointAtAppSection = endpoints.filter((_: any) => _[sectionsTier] === endpointObjAppSection && _[subSectionsId]);
        const subSections = [...new Set(endpointAtAppSection.map((_: any) => _[subSectionsId]))];

        tabItems.value = subSections;
    }

    /**
     * Navigates to the first endpoint with the sub section given
     * @param subSectionId 
     */
    function navigateTo (subSectionId: any): void {
        const endpoints = getCurrentTierEndpoints();
        const firstEndpointSubSection = endpoints.find((_: any) => _[subSectionsId] === subSectionId);
        const firstEndpointSubSectionID = firstEndpointSubSection.endpointId;

        router.push({ params: { endpointId: firstEndpointSubSectionID } })
    }
    
    /**
     * Navigates to the endpoint id given
     * @param endpointId
     */
    function navigateToEndpoint (endpointId: string): void {
        router.push({ params: { endpointId: endpointId } })
    }

    onMounted(getTabItems);

    return { tabItems, navigateTo, subSectionActive, pages, pageIndex, navigateToEndpoint }
}